<script setup lang="ts">
import { computed, inject, ref, Ref } from 'vue';
import { useSubmitQuoteStore } from '@/store/SubmitQuoteStore';

const dialogRef = inject('dialogRef') as Ref;
const quoteIdSocket = dialogRef?.value?.options.props.data;

const show = ref(true);
const submitQuoteStore = useSubmitQuoteStore();
const quoteId = computed(() => submitQuoteStore.selectQuoteId);
</script>

<template>
  <div class="modal-gqt">
    <Transition name="modal-gqt">
      <div v-if="show" class="modal-mask">
        <p class="modal-container text-center">
          {{ $t('common.your_quote_request') }}
          <br />{{ $t('common.a_group_co_will_touch_w_you') }}
        </p>
        <h5 class="mt-3 text-center" v-if="quoteId">{{ $t('advance_quote.quote_saved', { quoteId: quoteIdSocket || quoteId }) }}</h5>
      </div>
    </Transition>
  </div>
</template>
